/**
 * How an Oxford package order's payment status reads in admin.
 *
 * The stored value is Stripe's own PaymentIntent status, copied verbatim, plus
 * our `failed` for a card declined before an intent existed. It arrives as a
 * string off the wire rather than a closed set, so anything unrecognised is
 * shown as it arrived instead of being dropped.
 */
export function oxfordPaymentStatusLabel(status: string | null | undefined): string {
  switch (status) {
    case 'succeeded':
      return 'Paid';
    case 'requires_action':
      return 'Awaiting card authentication';
    case 'requires_payment_method':
    case 'requires_confirmation':
      return 'Payment not completed';
    case 'processing':
      return 'Payment processing';
    case 'requires_capture':
      return 'Payment authorised, not yet taken';
    case 'failed':
      return 'Payment failed';
    case 'canceled':
      return 'Cancelled';
    case 'pending':
      return 'Payment not started';
    default:
      return status || 'Unknown';
  }
}
